import type { URLOpenListenerEvent } from '@capacitor/app'

import { App as CapacitorApp } from '@capacitor/app'
import { isNative } from '@/helpers'
import {
  addListeners,
  registerNotifications,
  getDeliveredNotifications
} from '@/native/notifications'
import { useRouter } from 'vue-router'

export default async function init() {
  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    const router = useRouter()
    if (!canGoBack) {
      CapacitorApp.exitApp()
    } else {
      router.go(-1)
    }
  })

  CapacitorApp.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
    const router = useRouter()

    // Example url: https://trucktrust.duvadev.se/shared-location/%7B%22test%22%3A%22haha%22%7D
    const split = event.url.split('/').filter(Boolean)
    console.log('App url open', event, split)
    try {
      if (split.length < 2) {
        console.error('Invalid url', event.url)
        return
      }

      // Match path
      switch (split[1]) {
        case 'location':
          const idWithQuery = split[2]
          const [id, queryString] = idWithQuery.split('?')

          // Parse the query string into an object
          const query = queryString
            ? Object.fromEntries(new URLSearchParams(queryString))
            : {}

          // Navigate to the location route
          try {
            router.push({
              name: 'location',
              params: { id }, // Pass the `id` as a route parameter
              query // Pass the query parameters as a separate object
            })
          } catch (error) {
            console.error(
              'Error navigating using router, falling back to window.location:',
              error
            )
            // Fallback to window.location if router fails
            const url = new URL(window.location.href)
            url.pathname = `/location/${id}`
            Object.entries(query).forEach(([key, value]) => {
              url.searchParams.set(key, value)
            })

            window.location.href = url.toString()
          }
          break
        default:
          // Note: This is old code used for 'share-location', not sure if it still works
          // Get the last part of the url and decode it
          const data = JSON.parse(decodeURIComponent(split.pop() as string)) // Note: will probably change to a different encoding for the payload
          const path = split.pop() as string

          if (data && path) {
            console.log('Opening url', path, data)

            // TODO: Do some more stuff here like adding the location payload to the state so it can be used in the map, unless the route handles this itself

            router.push({ name: path, params: { data } })
          }
      }
    } catch (error) {
      console.error(error) // TODO: Better error handling, like showing a toast or something
    }
  })

  if (isNative) {
    // Notifications
    await addListeners()
    await registerNotifications()
    await getDeliveredNotifications()
  }
}
